import { FaroCoreApiTypes } from "@stellar/core-api-client";

/** Readable label of Sphere XG subscriptions */
export enum SubscriptionLabel {
  trial360 = "360° Trial",
  trialPointCloud = "Point Cloud Trial",
  trial360PointCloud = "Point Cloud & 360° Trial",
  standard360 = "360° Standard",
  standardPointCloud = "Point Cloud Standard",
  pro360 = "360° Professional",
  proPointCloud = "Point Cloud Professional",
  enterprise360 = "360° Enterprise",
  enterprisePointCloud = "Point Cloud Enterprise",
  enterprise360PointCloud = "Point Cloud & 360° Enterprise",
}

/**
 * Sphere XG Subscription
 */
export interface Subscription extends FaroCoreApiTypes.GetCompanySubscriptions {
  /** Readable label of the subscription */
  label: SubscriptionLabel;
}
